import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE = "/ann/ann-ai-cms/public/";

const ResourceDetail = () => {
  const { id } = useParams(); // ✅ Captures /resources/:id
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    const fetchBlog = async () => {
      try {
        const res = await fetch(`${API_BASE}api/contentinner/${id}`);
        const data = await res.json();
        if (data?.content) {
          setBlog(data.content);
        }
      } catch (err) {
        console.error("Error fetching blog detail:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!blog) return <div>No blog found.</div>;

  return (
    <div className="blog-detail-container">
      <h1>{blog.content_inner_title}</h1>
      {blog.content_inner_image && (
        <img
          src={`${API_BASE}${blog.content_inner_image}`}
          alt={blog.content_inner_title}
        />
      )}
      <div dangerouslySetInnerHTML={{ __html: blog.content_inner_text }}></div>
    </div>
  );
};

export default ResourceDetail;
